import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'version-issue-associated-designs.empty-state.title',
		defaultMessage: 'You’ll see your linked designs here',
		description:
			'The title of the design section empty state in Version details page, explaining what feature it could bring if user starts using it.',
	},
	desciption: {
		id: 'version-issue-associated-designs.empty-state.desciption',
		defaultMessage: 'Get live updates and greater visibility of your team’s design work.',
		description:
			'The description of the design section empty state in Version details page, explaining what feature it could bring if user starts using it.',
	},
	learnMoreLabel: {
		id: 'version-issue-associated-designs.empty-state.learn-more-label',
		defaultMessage: 'Read more about linking designs to Jira issues',
		description:
			'The CTA button label that links to the documentation where it explains how to link designs to issues',
	},
	learnMoreLabelIssueTerminologyRefreshM4: {
		id: 'version-issue-associated-designs.empty-state.learn-more-label-issue-terminology-refresh-m4',
		defaultMessage: 'Read more about linking designs to Jira work items',
		description:
			'The CTA button label that links to the documentation where it explains how to link designs to issues',
	},
});
